import ListCard from '@Components/ListCard/ListCard';
import AlertServices from '@Services/Alert.services.ts';
import { Notification } from '@Types/Asset.types';
import { PaginatedResponse } from '@Types/Response.types';
import { PAGE_PROP, PAGE_SIZE, PAGINATED_DEFAULT, PATHS, TABLE_STRUCTURES } from '@Utils/constants';
import { formatNotificationData } from '@Utils/format.utils.tsx';
import { handleRequestError } from '@Utils/request.utils';
import { Pagination, useTopHat } from '@kg-internal/pv3-uikit';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const Notifications = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [notifications, setNotifications] = useState<PaginatedResponse<Notification>>(PAGINATED_DEFAULT);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>();
  const currentPage = Number(searchParams.get(PAGE_PROP) ?? '1');

  useTopHat({
    activeNav: 'nav-home',
    activeTab: undefined,
    tabs: [],
    breadcrumbs: [
      { title: 'Home', href: PATHS.HOME, id: 'Home' },
      {
        title: 'Notifications',
        href: `${PATHS.NOTIFICATIONS}?page=${1}`,
        id: 'Notifications',
      },
    ],
  });

  useEffect(() => {
    setIsLoading(true);
    AlertServices.updateAlerts(currentPage, true)
      .then(({ data }) => {
        setNotifications(data);
        setErrorMessage(undefined);
      })
      .catch((error) => {
        handleRequestError(error, setErrorMessage);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage]);

  const handleNewPage = (newPage: number) => {
    if (newPage <= 0 || newPage > notifications.totalPages) {
      return;
    }
    searchParams.set(PAGE_PROP, newPage.toString());
    setSearchParams(searchParams);
  };

  return (
    <div className='grid'>
      <div className='col-12'>
        <ListCard<Notification>
          title="Notifications"
          structure={TABLE_STRUCTURES.NOTIFICATIONS}
          data={formatNotificationData(notifications)}
          loading={isLoading}
          withDetails
          detailsPath={PATHS.ASSETS}
          error={errorMessage}
        />
      </div>
      <div className='col-12 content-middle content-right-md'>
        <Pagination
          count={notifications.totalDocs}
          perPage={PAGE_SIZE}
          currentPage={currentPage - 1}
          onChange={(page) => handleNewPage(page + 1)}
        />
      </div>
    </div>
  );
};

export default Notifications;
